import { FullUserFragment } from 'graphql.generated';

import { CallState, LoadingState } from 'src/app/utilities/state.util';

export const newOpportunitySearchCustomersDialogInitialState = {
  show: false as boolean,
  query: '' as string,
  callState: LoadingState.INIT as CallState,
  customers: [] as FullUserFragment[],
};

export type NewOpportunitySearchCustomersDialogState = typeof newOpportunitySearchCustomersDialogInitialState;
